export default __webpack_public_path__ + "static/14aa-982d13cbed57183ce34a1e71d5674540.png";